import React, { useState } from 'react'
import { Box, MenuItem, TextField, Typography } from '@mui/material'
import { chunks } from '../../../../utils'
import { IEffect } from '../../../../api/types/effect'
import { WeaponProfTranslation } from '../../../../api/types/item'

interface Props {
  effect?: IEffect
  register: any
}

export const WeaponProfAttributes: React.FC<Props> = ({ effect, register }) => {
  const [profs, setProfs] = useState<[string, number][]>(
    Object.entries(effect?.weapon_proficiency || {})
      .filter(s => s[1] !== 0)
      .filter(s => s[0] !== 'id')
  )

  return (
    <Box sx={{ marginBottom: '8px' }}>
      <Typography variant="button" display="block" gutterBottom>
        Biegłości broni
      </Typography>

      {effect?.weapon_proficiency?.id && (
        <input
          type="hidden"
          name="effect_attributes.weapon_proficiency_attributes.id"
          value={effect?.weapon_proficiency?.id}
          ref={register()}
        />
      )}

      {profs.length < Object.keys(WeaponProfTranslation).length && (
        <Box sx={{ display: 'flex', marginBottom: '8px', marginLeft: '4px', marginRight: '4px' }}>
          <TextField
            select
            fullWidth={true}
            label="Dodaj modyfikator biegłości broni"
            value=""
            onChange={e => {
              e.preventDefault()
              setProfs(prevState => {
                if (!prevState.map(s => s[0]).includes(e.target.value)) {
                  return [[e.target.value, 1], ...prevState]
                }
                return [...prevState]
              })
            }}
          >
            {Object.entries(WeaponProfTranslation)
              .filter(wp => !profs.map(s => s[0]).includes(wp[0]))
              .map(wp => (
                <MenuItem key={wp[0]} value={wp[0]}>
                  {wp[1]}
                </MenuItem>
              ))}
          </TextField>
        </Box>
      )}

      {profs &&
        chunks(profs.sort(), 4).map((group: [string, number][]) => (
          <Box key={JSON.stringify(group)} sx={{ display: 'flex', marginBottom: '8px' }}>
            {group.map(wp => (
              <TextField
                key={`effect_attributes.weapon_proficiency_attributes.${wp[0]}`}
                sx={{ marginRight: '4px', marginLeft: '4px' }}
                type={'number'}
                fullWidth={true}
                name={`effect_attributes.weapon_proficiency_attributes.${wp[0]}`}
                defaultValue={wp[1]}
                label={WeaponProfTranslation[wp[0]] || wp[0]}
                variant="outlined"
                inputProps={{
                  ref: register(),
                }}
                onBlur={e =>
                  setProfs(prevState => [
                    ...prevState.filter(p => p[0] !== wp[0]),
                    [wp[0], Number(e.target.value)],
                  ])
                }
              />
            ))}
          </Box>
        ))}
    </Box>
  )
}
